// Ob der Browser gerade eine Verbindung meldet. "Meldet": navigator.onLine
// erkennt nur den Netzwerkadapter, nicht ob der Server wirklich erreichbar
// ist - fuer das Banner reicht das (Projektplan 10.1), fuer die Outbox
// entscheidet ohnehin der tatsaechliche Fehlschlag der Anfrage.

import { useEffect, useState } from "react";

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const wennOnline = () => setOnline(true);
    const wennOffline = () => setOnline(false);
    window.addEventListener("online", wennOnline);
    window.addEventListener("offline", wennOffline);
    return () => {
      window.removeEventListener("online", wennOnline);
      window.removeEventListener("offline", wennOffline);
    };
  }, []);

  return online;
}
